import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateUserDashboard = {
  userDashboard: { data: null, loading: false, error: null },
};

export const userDashboard = createAsyncThunk('user/userDashboard', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .get(`/user/dashboard`)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUserDashboard = {
  [userDashboard.pending]: (state) => {
    state.userDashboard.loading = true;
  },
  [userDashboard.fulfilled]: (state, action) => {
    state.userDashboard.loading = false;
    state.userDashboard.data = action.payload;
    state.userDashboard.error = null;
  },
  [userDashboard.rejected]: (state, action) => {
    state.userDashboard.loading = false;
    state.userDashboard.error = action.payload;
  },
};
